import { render, staticRenderFns } from "./PrintJobsModal.vue?vue&type=template&id=67548720&scoped=true&"
import script from "./PrintJobsModal.vue?vue&type=script&lang=ts&"
export * from "./PrintJobsModal.vue?vue&type=script&lang=ts&"
import style0 from "./PrintJobsModal.vue?vue&type=style&index=0&id=67548720&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67548720",
  null
  
)

export default component.exports